import axios from 'axios';
import csrfToken from '../../../shared/meta';
import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

const headers = {
  'X-CSRF-TOKEN': csrfToken(),
};

const base = '/api/v1/lwadmin/content_format_type';

export function useGetContentFormatTypes() {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}s`,
    method: 'GET',
  }, { manual: true });
}

export function createContentFormatType(payload) {
  return axios.post(base, payload, { headers });
}

export function updateContentFormatType(id, payload) {
  return axios.put(`${base}/${id}`, payload, { headers });
}
